const firebaseConfig = {
    apiKey: "AIzaSyD_tj9MgcWoOJWcsPVCigatXgQFgwyLwwY",
    authDomain: "solar-studio-d83bc.firebaseapp.com",
    databaseURL: "https://solar-studio-d83bc.firebaseio.com",
    projectId: "solar-studio-d83bc",
    storageBucket: "solar-studio-d83bc.appspot.com",
    messagingSenderId: "574034932624",
    appId: "1:574034932624:web:a3055957eea7d76346f915",
    measurementId: "G-0T79M4HC2Z"
};

export default firebaseConfig;




